import { Field, FieldProps } from 'formik';
import { Validations, gen_validate, validateCharacters } from '../../../helper/validation';
import { Addon, ShopContent } from '../../../types/cms_shared_types';
import { AddonListActions, Product, ProductListActions } from '../../../types/webshop';
import { Conditional } from '../../Common/Conditional';
import { ShoppingList } from '../ShoppingCart/ShoppingList';
import { TotalPrice } from '../ShoppingCart/TotalPrice';
import { TooltipHelper } from '../TooltipHelper';
import { useState } from 'react';

interface PriceSummaryProps {
  selectedProducts: Product[];
  selectedProductsActions: ProductListActions;
  selectedAddons: Addon[];
  selectedAddonsActions: AddonListActions;
  price: string;
  vatPrice: string;
  selectedCategoryKey?: string;
  selectedSubcategoryKey?: string;
  cmsShopContent: ShopContent;
}

export const PriceSummary: React.FC<PriceSummaryProps> = ({
  selectedProducts,
  selectedProductsActions,
  selectedAddons,
  selectedAddonsActions,
  price,
  vatPrice,
  selectedCategoryKey,
  selectedSubcategoryKey,
  cmsShopContent,
}) => {
  const [totalPriceFetching, setTotalPriceFetching] = useState(false);
  const validations: Validations<string> = [
    { validate: validateCharacters, errorMessage: cmsShopContent.invalidCharacterError },
  ];

  return (
    <div className="sm:pl-[54px]">
      <ShoppingList
        selectedProducts={selectedProducts}
        selectedProductsActions={selectedProductsActions}
        selectedAddons={selectedAddons}
        selectedAddonsActions={selectedAddonsActions}
        setTotalPriceFetching={setTotalPriceFetching}
        withEdit={true}
        selectedCategoryKey={selectedCategoryKey}
        selectedSubcategoryKey={selectedSubcategoryKey}
        cmsShopContent={cmsShopContent}
      >
        <div className="mt-6 mb-6 sm:mr-14">
          <div className="flex flex-row items-center mb-2">
            <div className="mr-2 text-sm font-bold text-text-dark">{cmsShopContent.summaryStep.informationTitle}</div>
            <TooltipHelper text={cmsShopContent.summaryStep.informationTooltip} />
          </div>
          <Field name={'summaryFormInputs'} validate={gen_validate(validations)}>
            {({ field, meta }: FieldProps<string>) => (
              <>
                <textarea
                  rows={3}
                  cols={40}
                  maxLength={800}
                  placeholder={cmsShopContent.summaryStep.informationPlaceholder}
                  className={`w-full min-h-[130px] sm:min-h-[100px] py-2 sm:py-3 px-3 sm:pl-6 sm:pr-4 align-top
                rounded-md bg-input-gray border border-input-border focus:outline-none ${
                  meta.error
                    ? 'text-red-darker border-sami-red focus:border-sami-red'
                    : 'text-text-dark focus:border-sami-green'
                }`}
                  {...field}
                />
                <Conditional
                  condition={!!meta.error && (meta.touched || !!field.value)}
                  trueRender={
                    <div className="flex flex-col pl-4 mt-2 text-sm font-medium text-sami-red">{meta.error}</div>
                  }
                />
              </>
            )}
          </Field>
        </div>
      </ShoppingList>

      <TotalPrice
        price={price}
        vatPrice={vatPrice}
        totalPriceFetching={totalPriceFetching}
        cmsShopContent={cmsShopContent}
      />
    </div>
  );
};
